import React, { useState } from 'react'
import { graphql } from 'gatsby'
import style from './clinic-card-mobile.mod.scss'
import { GatsbyImage } from 'gatsby-plugin-image'
import { Button, Divider } from '@components'
import { FaPlus, FaMinus } from 'react-icons/fa'

const ClinicCardMobile = ({
  button,
  description,
  directions,
  name,
  image,
  address,
  phone,
  fax,
  hours,
  waitTime = false,
  isAside,
  bookingLink,
  clinicLink,
  enrollmentLink,
  availableServices,
  modifiers = []
}) => {
  const { gatsbyImageData, alt } = image
  const [isDetailsOpen, setIsDetailsOpen] = useState(false)

  return (
    <div className={[style[`clinic-card-mobile`], ...modifiers].join(' ')}>
      <div className={style[`clinic-card-mobile__body`]}>
        <div className={style[`clinic-card-mobile__image`]}>
          {name && !isAside && (
            <div className={style[`clinic-card-mobile__header`]}>
              <h3>{name}</h3>
            </div>
          )}
          {waitTime && (
            <div className={style[`clinic-card-mobile__wait-time`]}>
              <div className={style[`clinic-card-mobile__wait-time__text`]}>
                Current Drop-inCare wait time:{' '}
                <div
                  className={
                    style[`clinic-card-mobile__wait-time__text__value`]
                  }
                >
                  {waitTime}
                </div>
              </div>
            </div>
          )}
          <div className={style[`clinic-card-mobile__image-gradient`]}></div>
          <GatsbyImage image={gatsbyImageData} alt={alt || ''} />
        </div>
        <div className={style[`clinic-card-mobile__content`]}>
          {/* {description && (
            <div
              className={style[`clinic-card-mobile__description`]}
              dangerouslySetInnerHTML={{ __html: description }}
            />
          )} */}

          {availableServices && (
            <div className={style[`clinic-card-mobile__available-services`]}>
              <div
                className={
                  style[`clinic-card-mobile__available-services__list`]
                }
              >
                {availableServices.map(service => (
                  <div
                    className={
                      style[
                        `clinic-card-mobile__available-services__list__item`
                      ]
                    }
                    key={service.id}
                  >
                    <div
                      className={`${
                        style[`theme-${service.theme[0].scheme}`]
                      } ${
                        style[
                          'clinic-card-mobile__available-services__list__item--pill'
                        ]
                      }`}
                    >
                      {service.title}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          <div className={style[`clinic-card-mobile__details-accordion`]}>
            <button
              className={style[`clinic-card-mobile__details-header`]}
              onClick={() => setIsDetailsOpen(!isDetailsOpen)}
              aria-expanded={isDetailsOpen}
            >
              <span className={style[`clinic-card-mobile__details-title`]}>
                {'Clinic Information'}
              </span>
              <span className={style[`clinic-card-mobile__details-icon`]}>
                {isDetailsOpen ? <FaMinus /> : <FaPlus />}
              </span>
            </button>
            {isDetailsOpen && (
              <div className={style[`clinic-card-mobile__details`]}>
                {address && (
                  <div className={style[`clinic-card-mobile__address`]}>
                    <p className={style[`clinic-card-mobile__key`]}>
                      {'Address:'}
                    </p>
                    <a href={directions} target="_blank">
                      {address}
                    </a>
                  </div>
                )}

                {phone && (
                  <div className={style[`clinic-card-mobile__phone`]}>
                    <p className={style[`clinic-card-mobile__key`]}>
                      {'Phone:'}
                    </p>
                    <a
                      href={`tel:${phone.replace(' ', '')}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className={style[`clinic-card-mobile__value`]}
                    >
                      {phone}
                    </a>
                  </div>
                )}
                {fax && (
                  <div className={style[`clinic-card-mobile__fax`]}>
                    <p className={style[`clinic-card-mobile__key`]}>{'Fax:'}</p>
                    <p className={style[`clinic-card-mobile__value`]}>{fax}</p>
                  </div>
                )}
                {hours && (
                  <div className={style[`clinic-card-mobile__hours`]}>
                    <p className={style[`clinic-card-mobile__key`]}>
                      {'Hours:'}
                    </p>
                    <div
                      className={style[`clinic-card-mobile__value`]}
                      dangerouslySetInnerHTML={{ __html: hours }}
                    />
                  </div>
                )}
              </div>
            )}
          </div>

          <div className={style[`clinic-card-mobile__buttons`]}>
            {bookingLink ? (
              <Button
                to={bookingLink}
                buttonStyle={'secondary'}
                length={'large'}
              >
                {'Book Now'}
              </Button>
            ) : enrollmentLink ? (
              <Button
                to={enrollmentLink}
                buttonStyle={'secondary'}
                length={'large'}
              >
                {'Enrol'}
              </Button>
            ) : null}
            {clinicLink && (
              <div className={style[`clinic-card-mobile__more-button`]}>
                <Button
                  to={clinicLink.path}
                  color={'inverse'}
                  buttonStyle={'secondary'}
                  length={'large'}
                >
                  {'View Clinic'}
                </Button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClinicCardMobile

export const query = graphql`
  fragment ClinicCardMobile on DatoCmsClinic {
    id
    name
    description
    address
    phone
    fax
    hours
    bookingLink
    enrollmentLink
    clinicLink {
      path
    }
    directions
    image {
      gatsbyImageData(
        layout: FULL_WIDTH
        imgixParams: { h: "224", w: "404", fit: "crop", q: 60 }
      )
      alt
    }
    availableServices {
      id
      title
      veryShortDescription
      theme {
        scheme
      }
    }
  }
`
